module.exports = __webpack_public_path__ + "img/cg.bdabbed0.png";